module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"openlayers","commonjs2":"openlayers","amd":"openlayers","root":"ol"}
// module id = 2
// module chunks = 0